<template>
  <path
    d="M14,3c-1.1173.0113-2.2252-.2044-3.2566-.6342-1.0314-.4297-1.9647-1.0645-2.7434-1.8658-.7787.8013-1.712,1.4361-2.7434,1.8658-1.0314.4297-2.1393.6455-3.2566.6342,0,0-.525,9,6,12.5,6.525-3.5,6-12.5,6-12.5Z"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
  <path
    d="M11.25,6l-3.5,3.5-1.75-1.75"
    fill="none"
    stroke="#fddc03"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width=".6667"
  />
</template>
